import template from './departments.html';
import tr from '../../lib/default-translator.js';

class AdminDepartmentsViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_departments_help()
	{
		Grape.dialog.open('DepartmentsHelp', { employee_id: this.page.bindings.id });
	}
}

class AdminDepartmentsPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminDepartmentsViewModel(this);
		document.title = tr('Manage Departments');
		window.current_page_title(tr('Add/Edit Departments'));
	}
}

export default {
	route: '[/]admin/departments',
	page_class: AdminDepartmentsPage,
	template: template,
	template_filename: 'translation/departments'
};
